// API Configuration
export const API_BASE_URL = 'https://api.ptshub.in';

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: `${API_BASE_URL}/auth/login.php`,
  LOGOUT: `${API_BASE_URL}/auth/logout.php`,
  VERIFY: `${API_BASE_URL}/auth/verify.php`,
  CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password.php`,
  
  // CRUD Operations
  ROLES: `${API_BASE_URL}/roles/index.php`,
  USERS: `${API_BASE_URL}/users/index.php`,
  CLASSES: `${API_BASE_URL}/classes/index.php`,
  CLASSES_REORDER_ROLL: `${API_BASE_URL}/classes/reorder_roll_numbers.php`,
  STUDENTS: `${API_BASE_URL}/students/index.php`,
  STUDENT_DETAILS: `${API_BASE_URL}/students/details.php`,
  STUDENTS_GENERATE_PDF: `${API_BASE_URL}/students/generate_pdf.php`,
  SUBJECTS: `${API_BASE_URL}/subjects/index.php`,
  CLASS_SUBJECTS: `${API_BASE_URL}/classsubjects/index.php`,
  EXAMS: `${API_BASE_URL}/exams/index.php`,
  MARKS: `${API_BASE_URL}/marks/index.php`,
  ATTENDANCE: `${API_BASE_URL}/attendance/index.php`,
  NOTIFICATIONS: `${API_BASE_URL}/notifications/index.php`,
  NOTIFICATION_USERS: `${API_BASE_URL}/notificationusers/index.php`,
  LEAVE_ALLOCATION: `${API_BASE_URL}/leaveallocation/index.php`,
  LEAVE_REQUESTS: `${API_BASE_URL}/leaverequests/index.php`,
  DASHBOARD: `${API_BASE_URL}/dashboard/index.php`,
  TEACHER_DASHBOARD: `${API_BASE_URL}/teacher/dashboard.php`,
  ACTIVITIES: `${API_BASE_URL}/activities/index.php`,
  ANNOUNCEMENTS: `${API_BASE_URL}/announcements/index.php`,
  APPCONFIG: `${API_BASE_URL}/appconfig/index.php`,
  APPCONFIG_PUBLIC_THEME: `${API_BASE_URL}/appconfig/public_theme.php`,
  UPLOAD: `${API_BASE_URL}/upload/index.php`,
  PERIODS: `${API_BASE_URL}/periods/index.php`,
  TIMETABLE: `${API_BASE_URL}/timetable/index.php`,
  CONTACT: `${API_BASE_URL}/contact/index.php`,
  FEE_CATEGORIES: `${API_BASE_URL}/fees/categories/index.php`,
  FEE_CLASS_FEES: `${API_BASE_URL}/fees/classes/index.php`,
  FEE_STUDENT_FEES: `${API_BASE_URL}/fees/students/index.php`,
  FEE_INVOICES: `${API_BASE_URL}/fees/invoices/index.php`,
  FEE_INVOICE_STUDENT: `${API_BASE_URL}/fees/invoices/student.php`,
  FEE_PAYMENTS: `${API_BASE_URL}/fees/payments/index.php`,
  FEE_PAYMENT_BILL: `${API_BASE_URL}/fees/payments/bill.php`,
  FEE_STATUS: `${API_BASE_URL}/fees/status/index.php`,
  PROMOTION_SUMMARY: `${API_BASE_URL}/classes/promotion/index.php`,
  PROMOTION_EXECUTE: `${API_BASE_URL}/classes/promotion/execute.php`,
  EMAIL_TEST: `${API_BASE_URL}/email_template/test_send.php`,
  SESSIONS: `${API_BASE_URL}/sessions/index.php`,
  ACTIVITY_LOGS: `${API_BASE_URL}/activity_logs/index.php`, // Activity logs endpoint
  FEEDBACK: `${API_BASE_URL}/feedback/index.php`,
};

// API Helper Functions
export const apiRequest = async (endpoint, options = {}) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(endpoint, config);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'API request failed');
    }
    
    return data;
  } catch (error) {
    console.error('API Request Error:', error);
    throw error;
  }
};

// Axios Configuration
export const axiosConfig = {
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false, // Set to false for CORS
  crossDomain: true,
};
